import React from "react";
import { Close } from "../../assets/svg";

const ServicesLeftModal = ({ isOpen, onClose }) => {
  const data = [
    {
      id: 1,
      outlet: "Outlet Name 1",
      date: "dd/mm/yyyy",
      technician: "Technician Name 1",
    },
    {
      id: 2,
      outlet: "Outlet Name 2",
      date: "dd/mm/yyyy",
      technician: "Technician Name 2",
    },
    {
      id: 3,
      outlet: "Outlet Name 3",
      date: "dd/mm/yyyy",
      technician: "Technician Name 3",
    },
    {
      id: 4,
      outlet: "Outlet Name 4",
      date: "dd/mm/yyyy",
      technician: "Technician Name 4",
    },
    {
      id: 5,
      outlet: "Outlet Name 5",
      date: "dd/mm/yyyy",
      technician: "Technician Name 5",
    },
    {
      id: 6,
      outlet: "Outlet Name 6",
      date: "dd/mm/yyyy",
      technician: "Technician Name 6",
    },
    {
      id: 6,
      outlet: "Outlet Name 6",
      date: "dd/mm/yyyy",
      technician: "Technician Name 6",
    },
    {
      id: 6,
      outlet: "Outlet Name 6",
      date: "dd/mm/yyyy",
      technician: "Technician Name 6",
    },
    {
      id: 6,
      outlet: "Outlet Name 6",
      date: "dd/mm/yyyy",
      technician: "Technician Name 6",
    },
    {
      id: 6,
      outlet: "Outlet Name 6",
      date: "dd/mm/yyyy",
      technician: "Technician Name 6",
    },
  ];

  return (
    <div className="model" onClick={onClose}>
      <div
        className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-3xl py-8 px-6 lg:mx-auto mx-3 relative h-1/2 overflow-auto"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="flex items-center justify-between p-4 ">
          <h4 className="font-Montserrat sm:text-3xl text-xl font-normal">
            Outlet Yet to Service
          </h4>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 focus:outline-none"
          >
            <Close />
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto text-left">
            <thead>
              <tr className="bg-bgLightTheme text-gray-600 shadow-sm">
                <th className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start">
                  No.
                </th>
                <th className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start">
                  Outlet
                </th>
                <th className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start">
                  Last Service Date
                </th>
                <th className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start">
                  Technician
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr
                  key={item.id}
                  className="font-Proxima text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
                >
                  <td className="px-5 py-3">{index + 1}</td>
                  <td className="px-5 py-3">{item.outlet}</td>
                  <td className="px-5 py-3">{item.date}</td>
                  <td className="px-5 py-3">{item.technician}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ServicesLeftModal;
